import { createPrefixer } from '.'

const ROOT = 'ver-logistpg' as const
export const RESOURCE_LOGISTICA_PG = 'Logistica PG' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pm = createPrefixer(ROOT, 'mantenimiento')
const pt = createPrefixer(ROOT, 'transacciones')
const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')

const permission = {
    _root: ROOT,
    _resource: RESOURCE_LOGISTICA_PG,
    mantenimiento: {
        _perm: rp('mantenimiento'),
        registroChoferes: pm('registro-chofer'),
        gestionChoferes: pm('gestion-choferes'),
        registroVehiculo: pm('registro-vehiculo'),
        gestionVehiculos: pm('gestion-vehiculos'),
        rutaViaje: pm('ruta-viaje'),
        asignacionProductoEntidad: pm('asignacion-producto-entidad'),
        gestionCuentaLogistica: pm('gestion-cuenta-logistica'),
        tipoLogistica: pm('tipo-logistica'),
    },
    transacciones: {
        _perm: rp('transacciones'),
        custodio: {
            _perm: pt('custodio'),
            gestionCustodio: pt('gestion-custodio'),
            crearCustodio: pt('crear-custodio'),
            custodioGuiaMovilizacion: pt('custodio-guia-movilizacion'),
        },
        gestionGuiaMovilizacion: pt('gestion-guia-movilizacion'),
        guiaMovilizacion: pt('guia-movilizacion'),
        gestionAlcanceHielo: pt('gestion-alcance-hielo'),
        alcanceHielo: pt('alcance-hielo'),
        alcanceVarios: pt('alcance-varios'),
        conciliacionGuias: pt('conciliacion-guias'),
        conciliacionGuiasHielo: pt('conciliacion-guias-hielo'),
        conciliacionAlcances: pt('conciliacion-alcances'),
        cierreMasivoConciliacion: pt('cierre-masivo-conciliacion'),
        aprobacionAperturaConciliacion: pt('aprobacion-apertura-conciliacion'),
        gestionConciliacion: pt('gestion-conciliacion'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        precioRuta: pc('precio-ruta'),
    },
    informes: {
        _perm: rp('informes'),
        reporteGuias: pi('reporte-guias'),
        reporteAlcances: pi('reporte-alcances'),
        reporteViajesPlanta: pi('reporte-viajes-planta'),
        distributivoPagoLogistico: pi('distributivo-pago-logistico'),
    },
}

export default permission
